import { CheckCircle, XCircle, Clock } from 'lucide-react';

export const CAUTION_PALIER = 5000;

export function Spinner() {
  return <div className="flex items-center justify-center p-12"><div className="w-8 h-8 border-2 border-[#FF6B35] border-t-transparent rounded-full animate-spin" /></div>;
}

export function KpiBox({ label, value, color }) {
  return (
    <div className="bg-[#1B1B1B] rounded-sm p-3 text-center">
      <p className="font-mono text-xl font-bold" style={{ color }}>{value}</p>
      <p className="text-[9px] text-[#A1A1AA]">{label}</p>
    </div>
  );
}

export function MetricDelta({ label, j0, now, unit, lower }) {
  if (!j0) return <div><p className="text-[#A1A1AA]">-</p><p className="text-[9px] text-[#A1A1AA]">{label}</p></div>;
  const delta = now ? (now - j0) : 0;
  const good = lower ? delta < 0 : delta > 0;
  return (
    <div>
      <p className="font-mono text-sm text-[#FAFAFA]">{now || '-'}{unit}</p>
      {delta !== 0 && <p className={`text-[10px] font-mono ${good ? 'text-[#2e7d32]' : 'text-[#c0392b]'}`}>{delta > 0 ? '+' : ''}{delta.toFixed(1)}</p>}
      <p className="text-[9px] text-[#A1A1AA]">{label} (J0: {j0})</p>
    </div>
  );
}

export function ProgressBar({ p, last }) {
  if (!p.poids_j0 || !last) return null;
  const total = p.poids_j0 - (p.cible_poids || p.poids_j0);
  const done = p.poids_j0 - last.poids;
  const pct = total > 0 ? Math.min(100, Math.max(0, (done / total) * 100)) : 0;
  return (
    <div className="h-2 bg-[#A1A1AA]/20 rounded-full overflow-hidden">
      <div className="h-full rounded-full transition-all" style={{ width: `${pct}%`, backgroundColor: p.objectif === 'gras' ? '#FF6B35' : '#2e7d32' }} />
    </div>
  );
}

export function StatusIcon({ status }) {
  if (status === 'vert') return <CheckCircle className="w-4 h-4 text-[#2e7d32]" />;
  if (status === 'rouge') return <XCircle className="w-4 h-4 text-[#c0392b]" />;
  return <Clock className="w-4 h-4 text-[#888888]" />;
}
